let cookieUtils = {
    knownParams: ['propertyid', 'developmentid'],

    setTrackingDetailsCookie: function() {
        // check user has consented to functional cookies
        let optanonConsentCookie = cookieUtils.getOptanonConsentCookie();
        if (optanonConsentCookie && optanonConsentCookie.groups.C0003 === '1') {
            if (cookieUtils.isTrackableURL()) {
                let thisURL = new URL(window.location);
                let searchParams = new URLSearchParams(window.location.search);
                    searchParams = cookieUtils.removeKnownWebsiteParams(searchParams);
                    document.cookie = `trackingDetailsCookie=${searchParams.toString()}; domain=.${thisURL.hostname}; max-age=${60*60*24*84}; Path=/; Secure`;
            }
        }
    },
    isTrackableURL: function() {
        let trackable = false;
        let paramsString = window.location.search;
        if (paramsString.length) {
            let searchParams = new URLSearchParams(paramsString.toLowerCase());
            if (searchParams.has('utm_source') || searchParams.has('utm_campaign')) {
                trackable =  true;
            }
        }
        return trackable;
    },
    getOptanonConsentCookie: function() {
        let optCookieValues;
        let documentCookies = decodeURIComponent(document.cookie);
        let optanonConsentCookie = documentCookies.split("; ").find((row) => row.startsWith("OptanonConsent="));
        if (optanonConsentCookie) {
            // remove the cookie name
            let optValue = optanonConsentCookie.split('=');
            optValue.shift();
            // Get the Cookie Key Value pairs
            let keyValuePairs = optValue.join('=').split('&');
            let keyValues = [];
            keyValuePairs.forEach((keyValuePair) => {
                keyValues.push(keyValuePair.split('='));
            });
            optCookieValues = Object.fromEntries(keyValues);
            // Get the Consent Groups
            if (optCookieValues.groups) {
                keyValues = [];
                keyValuePairs = optCookieValues.groups.split(',');
                keyValuePairs.forEach((keyValuePair) => {
                    keyValues.push(keyValuePair.split(':'));
                });
                optCookieValues.groups = Object.fromEntries(keyValues);
            } else {
                optCookieValues.groups = {C0001:'1',C0003:'0',C0002:'0',C0004:'0',C0005:'0'};
            }
        }
        return optCookieValues;
    },
    removeKnownWebsiteParams: function(urlSearchParams) {
        let deleteKeys = [];
        urlSearchParams.forEach((value, key) => {
            if (cookieUtils.knownParams.find((param) => param === key.toLowerCase())) {
                deleteKeys.push(key);
            }
        });
        deleteKeys.forEach((key) => urlSearchParams.delete(key));
        return urlSearchParams;
    }
};
document.addEventListener("DOMContentLoaded", () => {
    // If user has not accepted cookies and the URL is trackable we need to handle consent being changed
    // this uses the OneTrust API, but it cannot be called until after the Banner has been displayed
    let documentCookies = decodeURIComponent(document.cookie);
    let optanonAlertBoxCookie = documentCookies.split("; ").find((row) => row.startsWith("OptanonAlertBoxClosed="));
    let optanonConsentCookie = documentCookies.split("; ").find((row) => row.startsWith("OptanonConsent="));
    if (!(optanonConsentCookie && optanonAlertBoxCookie) && cookieUtils.isTrackableURL()) {
        const targetNode = document.querySelector("body");

        // We're just interested in the cookie banner which is added to the body
        const config = { attributes: false, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        const callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if (mutation.type === "childList") {
                    // if elements have been added
                    if (mutation.addedNodes.length) {
                        mutation.addedNodes.forEach((node) => {
                            if (node.id == 'onetrust-banner-sdk') {
                                // OneTrust Banner Set up, add  on Consent Changed handler
                                OneTrust.OnConsentChanged( () => {
                                    cookieUtils.setTrackingDetailsCookie();
                                });
                                observer.disconnect();
                            }
                        });
                    }
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    }

});
